import { startNativeDownload } from '../../../services/base/BaseApi';
import { BaseDataService } from '../../../services/base/BaseDataService';
import { ReadDataService } from '../../../services/base/ReadDataService';
import { ProjectDocSigner } from './ProjectDocSigner';
import { ProjectDocSignerRole } from './ProjectDocSignerRole';
import { AxiosResponse } from 'axios';
import { withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';

export interface ProjectDocSignerQuery {
    ProjectDocId?: number;
    RoleId?: number;
    RoleIds?: number[];
    ActTypeId?: number;
    IsDeleted?: boolean;
    Includes?: string[];
}

export interface ProjectDocSignerRoleQuery {
    Ids?: number[];
    Includes?: string[];
}

export class ProjectDocSignerService extends BaseDataService<ProjectDocSigner, ProjectDocSignerQuery> {
    protected prefixUrl: string = `ProjectDocSigners`;

    validate(data: ProjectDocSigner[]) {
        if (data.some(signer => typeof signer.BasisDocumentUpload?.Content === 'string')) {
            return this.api.post<string[]>(`${this.prefixUrl}/Validate`, data, withUploadRejectionDetection());
        }
        return this.api.post<string[]>(`${this.prefixUrl}/Validate`, data);
    }

    save(data: ProjectDocSigner[]) {
        if (data.some(signer => typeof signer.BasisDocumentUpload?.Content === 'string')) {
            return this.api.post<ProjectDocSigner[]>(`${this.prefixUrl}/save`, data, withUploadRejectionDetection());
        }
        return super.save(data);
    }

    async downloadBasisDocument(signerId: number) {
        await startNativeDownload(`${this.prefixUrl}/DownloadBasisDocument?signerId=${signerId}`);
        return { data: new Blob() } as AxiosResponse<Blob>;
    }

    validateByProjectDoc(projectDocId: number) {
        return this.api.get<string[]>(`${this.prefixUrl}/ValidateByProjectDoc?projectDocId=${projectDocId}`);
    }

    validateForActTemplate(data: { projectDocId: number; actTemplateId: number }) {
        return this.api.post<string[]>(`${this.prefixUrl}/ValidateForActTemplate`, data);
    }
}

export class ProjectDocSignerRoleService extends ReadDataService<
    ProjectDocSignerRole,
    ProjectDocSignerRoleQuery,
    number
> {
    protected prefixUrl: string = `ProjectDocSignerRoles`;
}
